import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import EternioButton from './components/global/EternioButton.vue'
import 'document-register-element/build/document-register-element'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(vueCustomElement)

axios.defaults.baseURL = 'https://api.eternio.com'

Vue.component('eternio-button', EternioButton)

App.store = store
App.router = router
App.vuetify = vuetify
Vue.customElement('eternio-explore', App)
